document.addEventListener('DOMContentLoaded', function() {
  
  const sections = document.querySelectorAll('.zoy-cc-section');
  
  sections.forEach(section => {
    // 1. Tab Switching Logic
    const tabBtns = section.querySelectorAll('.zoy-cc-tab-btn');
    const tabContents = section.querySelectorAll('.zoy-cc-tab-content');
    
    tabBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        
        // Remove active class from all buttons and contents
        tabBtns.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));
        
        // Add active class to clicked button and target content
        this.classList.add('active');
        const targetContent = section.querySelector('#' + targetId);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });

    // 2. Carousel Arrow & Pagination Logic
    
    tabContents.forEach(tab => {
      const scrollContainer = tab.querySelector('.zoy-cc-features-grid');
      const prevBtn = tab.querySelector('.zoy-cc-arrow-prev');
      const nextBtn = tab.querySelector('.zoy-cc-arrow-next');
      const dots = tab.querySelectorAll('.zoy-cc-dot');
      
      if (!scrollContainer) return;
      
      // Arrow clicks (Desktop)
      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', function() {
          const cardWidth = scrollContainer.children[0].offsetWidth + 20;
          scrollContainer.scrollBy({ left: -cardWidth, behavior: 'smooth' });
        });
        
        nextBtn.addEventListener('click', function() {
          const cardWidth = scrollContainer.children[0].offsetWidth + 20;
          scrollContainer.scrollBy({ left: cardWidth, behavior: 'smooth' });
        });
      }

      // Pagination dots scroll tracking (Mobile)
      if (dots.length > 0) {
        scrollContainer.addEventListener('scroll', function() {
          const scrollPosition = scrollContainer.scrollLeft;
          const cardWidth = scrollContainer.children[0].offsetWidth + 20;
          const activeIndex = Math.round(scrollPosition / cardWidth);
          
          dots.forEach((dot, index) => {
            if(index === activeIndex) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        });
      }
    });
    
  });
});
